module.exports = __webpack_public_path__ + "static/img/partner6.638341b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partner6.png
// module id = ujrZ
// module chunks = 8